import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { CustomMenu } from '../../menus/custom-menu';
import { LocaleSwitcher } from '../../i18n/locale-switcher';
import { Button } from '../buttons/button';
import { DarkModeIcon } from '../../icons/material/DarkMode';
import { LightbulbIcon } from '../../icons/material/Lightbulb';
import { Trans } from '../../i18n/trans';
import { useThemeSelector } from '../themes/theme-selector-context';
import { useSettings } from '../../core/settings/use-settings';
import { useCustomMenu } from '../../menus/use-custom-menu';
import { createSvgIcon } from '../../icons/create-svg-icon';

interface Props {
  className?: string;
  padding?: string;
  
}

export function Footer({ className, padding }: Props) {
  const year = new Date().getFullYear();

  return (
    <>
<footer className="relative z-10 bg-primary text-white pt-20 md:px-12 lg:pt-[75px]">
<div className="elementor-divider">
			<span className="elementor-divider-separator">
						</span>
		</div>
  <div className=" mx-auto px-6 lg:px-2">
 
    <div className="-mx-4 flex md:mx-4 flex-wrap">
      <div className="px-6 sm:w-2/3 lg:w-1/4 ">
        <div className="w-full">
        <div className='flex flex-wrap -mx-1 lg:-mx-8'>
          <img className="md:w-1/2 h-33 w-auto mb-4 object-contain" src="/images/cclogo.svg" alt="" />
         
         
          </div>
          <p className="font-normal text-justify my-4 text-base ">CONIACLOUD, the IT solution for stable, customized, and secure cloud storage solutions. Secure and protect your data with ease, ensuring accessibility and seamless sharing with other users at any time. Experience the state-of-the-art storage technology offered by CONIACLOUD and elevate your data management to new heights.</p>
        </div>
      </div>
      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg-footer font-semibold">Quick Links</h4>

          <ul className="space-y-4 mt-5">
            <li className="flex items-center flex-wrap flex-row">
              <Link to="/" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">Home
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="/features"  className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                Features
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="/pricing" target='_blank' className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Plans & Pricing
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="/contact" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Contact Us
              </Link>
            </li>

          </ul>
        </div>
      </div>
      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg-footer font-semibold">Services</h4>

          <ul className="space-y-4 mt-5">
            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                Shared Web
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                Hosting
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                VPS Hosting
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Dedicated Server
              </Link>
            </li>


            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Cloud Hosting
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Domain Names
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                License Keys
              </Link>
            </li>

          </ul>
        </div>
      </div>
      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg-footer font-semibold">Contact Us</h4>

          <ul className="space-y-4 mt-5">
          <li className="flex items-center flex-wrap flex-row">
          CONIACLOUD
            </li>

            <li className="flex items-center flex-wrap flex-row">
            Aşkan Mahallesi, Şahane Sk. No: 36 b
42090 Konya – Meram, Türkiye

            </li>
            
            <li className="flex items-center flex-wrap flex-row">
            Phone:&nbsp;<Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
              +90 332 300 00 11
              </Link>
            </li>
            
            <li className="flex items-center flex-wrap flex-row">
            E-mail:&nbsp; <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
            Support@CONIACLOUD.com
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row mt-20">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Follow Us
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <div className="flex mt-10 lg:mt-0  items-center space-x-6">
              <a target='_blank' href="https://www.linkedin.com/company/coniasoft/"><img src="images/linkedin1.png" alt="LinkedIn" className="w-8"/></a>
              <a target='_blank' href="https://www.facebook.com/profile.php?id=100092460917308"><img src="images/facebook1.png" alt="facebook" className="w-8 "/></a>
              <a target='_blank' href="https://twitter.com/ConiaSoft"><img src="images/twitter1.png" alt="Twitter" className="w-8"/></a>
              <a target='_blank' href="https://www.instagram.com/coniasoft/"><img src="images/insta.png" alt="InstaGram" className="w-8"/></a>
                      
             
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>

  </div>
  <div className="elementor-divider_bottom">
			<span className="elementor-divider-separator">
						</span>
		</div>
<footer className="mb-4">

  <div className="px-10 py-5 flex flex-col md:flex-row lg:flex-row mb-0 lg:mt-0 items-center justify-between">
    <div className="flex lg:space-x-6  lg:flex-row flex-col text-center">
    <p className="text-[#FFFFFF] font-regular text-[14px] leading-2">Ⓒ 2023 - 2025 All Rights Reserved. Designed & Developed by <Link className='createdby' target='_blank' to="https://coniacloud.com/"><b>ConiaSoft Ⓡ Software Technologies Limited.</b></Link> </p>
     
    </div>
    {/* <div className="flex mt-10 lg:mt-0  items-center space-x-2">
      <p className="text-[#FFFFFF] font-regular text-[14px] leading-2"><Link to='https://coniacloud.com/privacy'>Privacy Policy</Link> &nbsp;</p>
     
    </div> */}
  </div>
</footer>
</footer>
   
   </>
  );
}

function Menus() {
  const settings = useSettings();
  const footerMenu1 = settings.menus.find(m => m.positions.includes('footer-1'));
  console.log('footerMenu1', footerMenu1)
  const footerMenu2 = settings.menus.find(m => m.positions.includes('footer-2'));
  const footerMenu3 = settings.menus.find(m => m.positions.includes('footer-secondary'));
  const secondaryMenu = settings.menus.find(m =>
    m.positions.includes('footer-secondary')
  );
  const menu1 = useCustomMenu(footerMenu1);
  const menu2 = useCustomMenu(footerMenu2);
  const menu3 = useCustomMenu(footerMenu3);

  console.log('footerMenu2',footerMenu2);



  return (
    <div className="-mx-4 flex md:mx-4 flex-wrap">
      <div className="px-6 sm:w-2/3 lg:w-1/4 ">
        <div className="w-full">
          <img className=" mb-4 object-contain" src="/images/cc.png" alt="" width="102px" />
          <p className="font-normal  my-4 text-base ">Nulla diam felis, malesuada ut erat quis,
            mattis dignissim justo. Cras cursus, lacus et dignissim volutpat</p>
        </div>
      </div>


      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg font-semibold">Quick Links</h4>

          <ul className="space-y-4 mt-5">
            {menu1 && menu1.items.map(item => {

              console.log('item', item);
              return (
                <>
                  <li className="flex items-center flex-wrap flex-row">
                    <Link to={item.action} className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">{item.label}
                    </Link>
                  </li>


                </>

              );
            })}
          </ul>
        </div>
      </div>


      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg font-semibold">Services</h4>

          <ul className="space-y-4 mt-5">
            {menu2 && menu2.items.map(item => {

              console.log('item2', item);
              return (
                <>
                  <li className="flex items-center flex-wrap flex-row">
                    <Link to={item.action} className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">{item.label}
                    </Link>
                  </li>


                </>

              );
            })}
          </ul>
        </div>
      </div>


      <div className="px-6 sm:w-1/2 lg:w-1/4">
        <div className="w-full">
          <h4 className="text-dark  text-lg font-semibold">Contact Us</h4>

          <ul className="space-y-4 mt-5">
            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                Support@coniacloud.com
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block text-sm leading-loose">
                +44 123 456 789-9
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row mt-20">
              <Link to="#" className="text-body-color hover:text-gray-100 inline-block  text-sm leading-loose">
                Follow Us
              </Link>
            </li>

            <li className="flex items-center flex-wrap flex-row">
              <div className="flex mt-10 lg:mt-0  items-center space-x-6">

                {menu3 && menu3.items.map(item => {
                  let icon = (item && item?.icon && item?.icon[0] && item?.icon[0]?.attr && item?.icon[0]?.attr.d)?item?.icon[0]?.attr.d:undefined;
                  console.log('secondaryMenu', menu3);
                  return (
                    <>
                      <li className="flex items-center flex-wrap flex-row">
                        <Link to={item.action}>

                          <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-testid="Icon" className="w-8" height="2em" width="1em"><path d={icon}></path></svg>
                        </Link>
                      </li>


                    </>

                  );
                })}
              </div>
            </li>

          </ul>
        </div>



      </div>




    </div>




  );
}

function ThemeSwitcher() {
  const { selectedTheme, selectTheme } = useThemeSelector();
  if (!selectedTheme) return null;

  return (
    <Button
      variant="text"
      startIcon={selectedTheme.is_dark ? <DarkModeIcon /> : <LightbulbIcon />}
      onClick={() => {
        if (selectedTheme.is_dark) {
          selectTheme('light');
        } else {
          selectTheme('dark');
        }
      }}
    >
      {selectedTheme.is_dark ? (
        <Trans message="Dark mode" />
      ) : (
        <Trans message="Light mode" />
      )}
    </Button>
  );
}
